module.exports = __webpack_public_path__ + "static/media/signal_head.b745bc0e.glb";